<template>
  <div>
    <b-modal
      centered
      id="upload-file-kpi"
      modal-class="overflow-hidden"
      static
      scrollable
      hide-footer
    >
      <template #modal-header="{ close }">
        <h5>
          Upload file KPI
          {{
            status === 'APPROVE'
              ? 'được duyệt'
              : status === 'ADDITIONAL'
                ? 'cần SA giải trình'
                : 'bị từ chối'
          }}
        </h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <div>
        <div class="content">
          <button class="font-medium f12 btn btn-outline-secondary" @click="importFile">
            Import file
          </button>
        </div>
        <div class="content">
          <button class="font-medium f12 btn mt-2" @click="downloadFile">Tải file mẫu</button>
        </div>
      </div>
    </b-modal>
    <input style="display: none" ref="uploadFileExcel" @change="uploadFileExcel" type="file" />
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import { DeviceService } from '@/services/device.service'
  export default {
    props: {
      status: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        title: '',
        showLoading: false,
      }
    },
    methods: {
      importFile() {
        this.$refs.uploadFileExcel.click()
      },
      async uploadFileExcel(file) {
        if (file.target.files.length === 0) return
        const allowedExtensions = /(\.xls|\.xlsx|\.csv|\.ods)$/i
        const checkFomat = allowedExtensions.exec(file.target.files[0].name)
        if (!checkFomat) {
          this.showFailMx('Định dạng không hợp lệ !')
          this.$refs.uploadFileExcel.value = null
          return
        }
        const formdata = new FormData()
        formdata.append('file', file.target.files[0])
        try {
          this.showLoading = true
          let res
          if (this.status === 'APPROVE') {
            res = await DeviceService.monitorApproveKpiReadFile(formdata)
          } else if (this.status === 'ADDITIONAL') {
            res = await DeviceService.monitorAdditionalKpiReadFile(formdata)
          } else res = await DeviceService.monitorRejectKpiReadFile(formdata)
          if (res.code === 1000) {
            const { listError, listCorrect } = res.data
            this.listDevice = listCorrect
            this.fileName = file.target.files[0].name
            this.showMsgOk(res.data)
          } else {
            this.showFailMx(res.message)
          }
        } catch (e) {
          this.showFailMx(e.message)
        } finally {
          this.$refs.uploadFileExcel.value = null
          this.showLoading = false
        }
      },
      async downloadFile() {
        try {
          this.showLoading = true
          const params = {
            actionMonitor: this.status,
          }
          await DeviceService.downloadFileKpiTemplate(params)
        } catch (error) {
          console.log(error)
          this.showFailMx(error.message ?? error)
        } finally {
          this.showLoading = false
        }
      },
      showMsgOk(data) {
        const h = this.$createElement
        // Using HTML string
        const titleVNode = h('div', {
          domProps: { innerHTML: 'Import file thành công' },
        })
        // More complex structure
        const messageVNode = h('div', { class: ['text-center'] }, [
          h('p', { class: ['text-center'] }, [
            'Số bản ghi thành công ',
            h('b', data.listCorrect.length),
            ' bản ghi',
          ]),
          h('p', { class: ['text-center'] }, [
            'Số bản ghi thất bại ',
            h('b', data.listError.length),
            ' bản ghi',
          ]),
          data.listError.length > 0 &&
            h(
              'button',
              {
                class: 'f12 font-medium btn btn-outline-danger',
                on: {
                  click: () => this.dowloadFileError(data.listError),
                },
              },
              `Tải ${data.listError.length} bản ghi thất bại`
            ),
          data.listCorrect.length > 0 &&
            h(
              'button',
              {
                class: 'f12 font-medium btn btn-outline-primary ml-2',
                on: {
                  click: () => this.acceptResultRecord(data.listCorrect),
                },
              },
              `Cập nhật kết quả ${data.listCorrect.length} bản ghi`
            ),
        ])
        this.$bvModal.msgBoxOk([messageVNode], {
          title: [titleVNode],
          centered: true,
        })
        this.$bvModal.hide('upload-file-kpi')
      },
      async dowloadFileError(reqs) {
        try {
          this.showLoading = true
          let res
          if (this.status === 'APPROVE') {
            res = await DeviceService.monitorApproveKpiDownloadFileError(reqs)
          } else if (this.status === 'ADDITIONAL') {
            res = await DeviceService.monitorAdditionalKpiDownloadFileError(reqs)
          } else res = await DeviceService.monitorRejectKpiDownloadFileError(reqs)
        } finally {
          this.showLoading = false
        }
      },
      async acceptResultRecord(data) {
        try {
          this.showLoading = true
          const params = this.prepareDataAccept(data)
          let response
          if (this.status === 'APPROVE') {
            response = await DeviceService.acceptResultApproveRecord(params)
          } else if (this.status === 'ADDITIONAL') {
            response = await DeviceService.acceptResultAdditionalRecord(params)
          } else response = await DeviceService.acceptResultRejectRecord(params)
          if (response.code === 1000) {
            this.showSuccessMx('Giám sát xác nhận thành công')
            this.$emit('reloadData')
            return true
          } else {
            throw new Error(response.message)
          }
        } catch (error) {
          console.log(error)
          this.showFailMx(error.message ?? error)
          return false
        } finally {
          this.showLoading = false
        }
      },
      prepareDataAccept(data) {
        let params
        if (this.status === 'APPROVE') {
          params = {
            ids: data.map(e => e.id),
          }
        } else {
          params = {
            notes: data.map(e => ({
              id: e.id,
              note: this.status === 'ADDITIONAL' ? e.reasonAdditional : e.reasonReject,
            })),
          }
        }
        return params
      },
    },
  }
</script>

<style scoped>
  .content {
    display: flex;
    justify-content: center;
  }
</style>
